import queryString from 'query-string';

function getParam(props, param) {
	return queryString.parse(props.location.search)[param] || '';
};

function downloadUrl(name, downloadUrl) {
	const a = document.createElement('a');
    document.body.appendChild(a);
    a.download = name;
    a.href = downloadUrl;
    a.click();
}

export default {
	downloadUrl,
	getParam
}